import type ModuleButtonsType from 'app/main/modules/components/ModuleButtonsType';
import { showDeleteDialog, showDetailsReportingDialog, Utils } from 'app/main/components';
import { showDocumentSettingsEditDialog } from 'app/main/components/dialogs/DocumentSettingsEditDialog';
import { shareDetailsPage } from 'app/main/components/dialogs/ShareDialog';

export default {
	view: {
		itemButtons: [
			// {
			// 	name: 'VIEW_ITEM_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'VIEW_ITEM_BUTTON_EDIT',
				icon: 'edit',
				action: ({ model }) => Utils.openLink({ pathname: `/sys/documents/folders/${model.fold_uid}/edit` }),
				hidden: ({ authorizer }) => authorizer.cannot('update', 'sys_documents_folders')
			},
			{
				name: 'VIEW_ITEM_BUTTON_ADD_COPY',
				icon: 'content-copy',
				iconAdd: true,
				action: ({ model, t }) => {
					const { fold_title } = model;
					Utils.openLink({
						pathname: '/sys/documents/folders/add',
						state: {
							model: { ...model, fold_title: fold_title + t('COPY') }
						}
					});
				}
			},
			{
				name: 'VIEW_ITEM_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'sys_documents_folders'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'sys_documents_folders',
							id: model.fold_uid,
							title: model.fold_title
						})
					)
			}
		],
		headerButtons: [
			// {
			// 	name: 'VIEW_HEADER_BUTTON_SELECT',
			// 	icon: 'square-outline',
			// 	action: ({ switchIsSelecting }) => switchIsSelecting()
			// },
			{
				name: 'VIEW_HEADER_BUTTON_NEW',
				icon: 'plus-circle',
				action: () => Utils.openLink({ pathname: '/sys/documents/folders/add' }),
				hidden: ({ authorizer }) => authorizer.cannot('create', 'sys_documents_folders')
			}
		]
	},
	details: {
		headerButtons: [
			// {
			// 	name: 'DETAILS_HEADER_BUTTON_FAVOURITE',
			// 	icon: 'star-outline',
			// 	disabled: () => true,
			// 	action: () => {}
			// },
			{
				name: 'DETAILS_HEADER_BUTTON_EXPORT',
				icon: 'file-export',
				action: ({ model, dispatch, settings, sysSettings }) =>
					showDetailsReportingDialog({ model, dispatch, settings, sysSettings })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHARE',
				icon: 'share-variant',
				action: ({ model, dispatch, settings, t }) => shareDetailsPage({ model, dispatch, settings, t })
			},
			{
				name: 'DETAILS_HEADER_BUTTON_REQUESTS_DOCUMENTS_SETTINGS',
				icon: 'folder-wrench',
				hidden: ({ authorizer }) => authorizer.cannot('update', 'requests'),
				action: ({ model, dispatch, updateRefresh, sysSettings }) =>
					dispatch(
						showDocumentSettingsEditDialog({
							module: 'sys_documents_folders',
							itemUid: model.fold_uid,
							folderName: model.fold_foldername,
							docsFolderPath: sysSettings.docs_path,
							updateRefresh
						})
					)
			},
			{
				name: 'DETAILS_HEADER_BUTTON_SHOW_LOG',
				icon: 'timeline-clock-outline',
				disabled: ({ isEdit }) => isEdit,
				action: ({ switchShowLogs }) => switchShowLogs()
			},
			{
				name: 'DETAILS_HEADER_BUTTON_DELETE',
				icon: 'delete',
				color: 'red',
				hidden: ({ authorizer }) => authorizer.cannot('delete', 'sys_documents_folders'),
				action: ({ model, dispatch }) =>
					dispatch(
						showDeleteDialog({
							module: 'sys_documents_folders',
							id: model.fold_uid,
							title: model.fold_title
						})
					)
			}
		],
		fabs: [
			{
				id: 'summary',
				name: 'ACTION_EDIT',
				icon: 'edit',
				action: ({ switchEdit }) => switchEdit()
			}
		]
	}
} as ModuleButtonsType;
